<template>
  <div class="main">
    <span class="main-config">
      <div v-if="!readOnly" class="op">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      <b-form v-if="operationSelected" class="b-layout" @submit.prevent="">
        <b-card class="pr-4">
          <div v-for="(prop, index) in equipments" :key="prop.caption + index">
            <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
            </b-form-checkbox>
          </div>
        </b-card>
        <b-card class="ml-3">
          <div class="inp">
            <label>{{ $t('tempo-de-cozimento-h') }} </label>
            <input
              class="input-pentagro"
              type="number"
              v-model="TempoNecessario.value"
            />
          </div>
          <div class="inp">
            <label>{{ $t('brix-de-saida') }} </label>
            <input
              min="0"
              class="input-pentagro"
              type="number"
              v-model="brixSaida.value"
            />
          </div>
          <div class="inp">
            <label>{{ $t('volume-instalado-m') }} </label>
            <p>{{ volume.value | ParseNumber }}</p>
          </div>
          <div class="inp">
            <label>{{ $t('tempo-resid-maxima-h') }} </label>
            <p>{{ TempoResidencia.value | ParseNumber }}</p>
          </div>
          <div class="inp">
            <label>{{ $t('ocupacao-1') }} </label>
            <p>{{ TxUtilizacao.value | ParseNumber }}</p>
          </div>
        </b-card>
      </b-form>
    </span>
      <div v-if="jokerEquipmentList.length" class="joker">
        <label class="mt-2 ">{{ $t('equipamentos-coringas') }}</label>
        <div v-for="(joker, i) in jokerEquipmentList" :key="i">
          <b-form>
            <div class="mr-2 mb-2">
              <TextToInput
                :text="joker.caption"
                @sendText="updateCaption($event, joker)"
              > >
              </TextToInput>
            </div>
            <span class="b-layout">
              <b-card>
                <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                  <b-form-checkbox
                    class="switch-item"
                    v-model="prop.value"
                    @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                    switch
                    >
                    {{ prop.equipName }}
                </b-form-checkbox>
                </div>
              </b-card>
              <div class="ml-3">
                <b-card>
                  <div class="inp mb-2">
                    <label>{{ $t('volume-instalado-m-0') }} </label>
                    <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                  </div>
                  <div class="inp">
                    <label>{{ $t('ocupacao-0') }} </label>
                    <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                  </div>
                </b-card>
              </div>
            </span>
          </b-form>
        </div>
      </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from "../../../mixins/jokerEquipmentsMixin";
import TextToInput from "../../../template/TextToInput";
import { FiltersMixin } from '../../../mixins/filtersMixin';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },

  mixins: [JokerEquipmentMixin, FiltersMixin],

  data() {
    return {
      TempoNecessario: {},
      brixSaida: {},
      volume: {},
      TempoResidencia: {},
      TxUtilizacao: {},
      operations: [{ value: null, text:this.$t('selecione-um-cozedor') }],
      operationSelected: null,
      currents: [{ value: null, text:this.$t('selecione-um-cozedor') }],
      current: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-um-cozedor'),
      firstLoad: false,
      equipments: [],
      equipCap: [],
      attrList: [
        "TempoNecessario",
        "brixSaida",
        "volume",
        "TempoResidencia",
        "TxUtilizacao",
      ],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attr) => {
        this[attr] = this.operationAttributeList.find((p) => attr == p.caption);
        if (this[attr]) this[attr].value = ParseToNumber(this[attr].value);
      });
      this.updateNode();
      this.jokerEquipmentList = [];
    },

    "TempoNecessario.value"() {
      this.updateNode();
    },

    "brixSaida.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.buildJokerEquipment(
          this.node.data[0].index,
          this.node.jokerCaption
        );
        this.firstLoad = true;
        this.loadNotInput();
      }

      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }
        
        if (p.equipName) {
          p.value = ParseToNumber(p.value) ? true : false;
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }

          if (props[p].caption == "Capacidade") {
            this.equipCap.push(props[p]);
          }
        });
      });

      if (!this.firstLoad) this.equipments = auxEquipment;
    },

    updateNode() {
      let attrs = [
        this.TempoNecessario.clone(),
        this.brixSaida.clone(),
      ];
      
      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? '1,00' : '0,00';
        attrs.push(prop);
      });
      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    updateCaption(caption, joker) {
      joker.caption = caption;
      this.updateNode();
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Cristalizador/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    ChangeCapacity() {
      if (this.volume) {
        this.volume.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap)
            this.volume.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
        });
      }
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacity();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade);
      this.updateNode();
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacity();
    this.changeExternalCapacity = function () {this.ChangeCapacity();};
    this.updataNodeInMixin = function () { this.updateNode();};
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 45px;
  text-align: right;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.op {
  margin: 2%;
}

.joker {
  margin: 10px;
  height: 350px;
  overflow-y: auto;
}
.main{
  display: flex;
}

.main-config{
  width: 680px;
}
</style>